import React from "react";
import { useLanguage } from "../../context/LanguageContext";
import { useNavigate } from "react-router-dom";

const SpecialOffers: React.FC = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="p-4 md:p-8 h-full shadow-lg rounded-lg bg-white overflow-y-auto">
      <p className="text-xl font-semibold">{t("contracts", "title")}</p>
      <br></br>

      <p className="text-sm">
        {t("contracts", "text1")}
        <br></br>
        <br></br>
        {t("contracts", "text2")}
        <br></br>
        <br></br>
        {t("contracts", "text3")}
        <br></br>
        <br></br>
        {t("contracts", "text4")}
        <br></br>
        <br></br>
        <strong>{t("contracts", "subTitle")}</strong>
      </p>

      <p className="mt-4 hover:text-[#FFC633]">
        <a
          onClick={() => {
            navigate("/contracts/kvkk");
          }}
        //   href="https://novamedshop.com.tr/contracts/kvkk"
        >
          - {t("contracts", "c1")}
          <a className="text-[10px]">({t("contracts", "more")})</a>
        </a>
      </p>
      <p className="mt-1 hover:text-[#FFC633]">
        <a
          onClick={() => {
            navigate("/contracts/privacy_and_security_policy");
          }}
          //   href="https://novamedshop.com.tr/contracts/privacy_and_security_policy"
        >
          - {t("contracts", "c2")}{" "}
          <a className="text-[10px]">({t("contracts", "more")})</a>
        </a>
      </p>
      <p className="mt-1 hover:text-[#FFC633]">
        <a
          onClick={() => {
            navigate("/contracts/distance_selling_contract");
          }}
          //   href="https://novamedshop.com.tr/contracts/distance_selling_contract"
        >
          -{t("contracts", "c3")}{" "}
          <a className="text-[10px]">({t("contracts", "more")})</a>
        </a>
      </p>
    </div>
  );
};

export default SpecialOffers;
